import { SyntheticEvent } from 'react';
import * as React from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import gettext from '@sdk/lang/gettext';
import DisplayText from '@sdk/components/ui/DisplayText';

import EditorToolbarButton from './EditorToolbarButton';

type Props = {
  isActive: boolean;
  activate: () => void;
};

const TextFocusButton: React.FC<React.PropsWithChildren<Props>> = ({ isActive, activate }) => {
  return (
    <EditorToolbarButton
      data-for="text-button-tip"
      data-tip={gettext('Write text')}
      data-place="top"
      borderRadius={2}
      isActive={isActive}
      onMouseDown={(e: SyntheticEvent): void => {
        e.preventDefault();
        activate();
      }}>
      <DisplayText
        fontSize={12}
        themeColor={isActive ? ThemeColorType.white : ThemeColorType.iconGray}>
        Aa
      </DisplayText>
      <Tooltip id="text-button-tip" attachToBody />
    </EditorToolbarButton>
  );
};

export default TextFocusButton;
